// extracted by mini-css-extract-plugin
module.exports = {"collapsible-list":"Mtnhudqs","header":"fmEe1ZZb"};